import * as Yup from "yup";


const emailValidation = Yup.string()
  .email("Please enter a valid email")
  .required("Email is required");

const passwordValidation = Yup.string()
  .min(6, "Password must be at least 6 characters")
  .required("Password is required");


export const loginValidationSchema = Yup.object().shape({
  // email: emailValidation,
  email: Yup.string().required("Email is required"),
  password: passwordValidation,
});


export const signupValidationSchema = Yup.object().shape({
  email: emailValidation,
  password: passwordValidation,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
  username: Yup.string().min(3, "Username must be at least 3 characters").required("Username is required"),
});
